import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {WebLoginRequest} from '../../../../services/authentication/model/webLoginRequest';
import {WebTokenModel} from '../../../../services/authentication/model/webTokenModel';
import {WebAccessRequest} from '../../../../services/authentication/model/webAccessRequest';
import {WebAccessModel} from '../../../../services/authentication/model/webAccessModel';

@Injectable({
    providedIn: 'root'
})

export class AuthenticationService {
    private serviceUrl = `${environment.apiUrl}/authentication`;

    constructor(
        private httpClient: HttpClient
    ) {
    }

    loginRequest(brokerId: string, request: WebAccessRequest): Observable<WebAccessModel> {
        const url = `${this.serviceUrl}/web/auth/access`;
        return this.httpClient.post<WebAccessModel>(url, request, {headers: {Public: 'true'}});
    }

    getTokenRequest(token: string, request: WebLoginRequest): Observable<WebTokenModel> {
        const url = `${this.serviceUrl}/web/auth/token/${token}`;
        return this.httpClient.post<WebTokenModel>(url, request, {headers: {Public: 'true'}});
    }

    getRefreshTokenRequest(refreshToken: string): Observable<WebTokenModel> {
        const url = `${this.serviceUrl}/web/auth/token/refresh/${refreshToken}`;
        return this.httpClient.get<WebTokenModel>(url, {headers: {Public: 'true'}});
    }
}
